// Lib
// Api
// Hooks
// Actions
// Selectors
// Types
// Theme
// Constants
// Helpers
// Utils
// Icons
// Layouts
// Components
// Styled

import { FC, memo } from "react";
import { ContentBox } from "styled/Box";
import { Typography } from "styled/Typography";
import { CustomerProfileResponseDto } from "types/customers";
import { BlockedState } from "../BlockedState";
import { MenuStatuses } from "../../types";
import { ProductItem } from "components";

interface LoyaltyBonusItemProps {
  isBlocked: boolean;
  loyaltyDiscountAvailable: boolean;
  customerData: CustomerProfileResponseDto;
  menuStatuses: MenuStatuses;
}

export const LoyaltyBonusItem: FC<LoyaltyBonusItemProps> = memo(
  ({ isBlocked, loyaltyDiscountAvailable, customerData, menuStatuses }) => {
    if (!loyaltyDiscountAvailable) {
      return null;
    }

    if (!customerData?.loyaltyData?.bonus?.isAvailable) {
      return null;
    }

    const { isClosed } = menuStatuses;

    const isUnAvailable = isBlocked || isClosed;

    const { bonus } = customerData?.loyaltyData || {};

    return (
      <ContentBox $column $gap={16} $position="relative" $minHeight="120px">
        <Typography.H2>Loyalty Tier Bonus</Typography.H2>

        <ProductItem
          name={bonus?.title || ""}
          imageURL={bonus?.imageUrl || ""}
        />

        {isUnAvailable && <BlockedState isClosed={isClosed} />}
      </ContentBox>
    );
  },
);

LoyaltyBonusItem.displayName = "LoyaltyBonusItem";
